import React, { useContext } from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown'
import UserContext from 'context/user-context'
import ThirdLineShieldNavy from 'assets/Shield/Navy/ThirdLineShieldNavy.svg'
import ThirdLineShieldGold from 'assets/Shield/Gold/ThirdLineShieldGold.svg'
import DatumLogo from 'assets/DatumInsights/datum-logo.webp'
import MutedText from 'shared/forms/muted-text'
import './app-switcher.css'

function AppSwitcher({ currentApp }) {
  const currentUser = useContext(UserContext)

  const switchTo = (app, defaultRoute) => {
    // Set localStorage directly instead of calling setCurrentApp to avoid
    // triggering a React re-render cycle. The useEffect in RenderApp would
    // see currentApp='datum' with the OLD route path, and clear the state
    // before the page navigates away.
    if (app) {
      localStorage.setItem('currentApp', app)
    } else {
      localStorage.removeItem('currentApp')
    }
    window.location.assign(defaultRoute)
  }

  return (
    <ul className="navbar-nav px-3">
      <NavDropdown
        title={
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="grid-2"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="svg-inline--fa fa-grid-2 fa-lg"
          >
            <path
              fill="currentColor"
              d="M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM288 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
              className=""
            ></path>
          </svg>
        }
        className="mx-2 text-white app-switcher-menu"
        align="end"
        menualign="left"
      >
        <div style={{ minWidth: '440px' }}>
          {currentUser.has_sod_app && (
            <NavDropdown.Item
              onClick={() => switchTo('sod', '/duties')}
              className={currentApp === 'sod' ? 'bg-light' : ''}
            >
              <div className="d-flex align-items-center">
                <img
                  src={ThirdLineShieldNavy}
                  className={`img-fluid ms-2 me-3 app-switcher-icon ${currentApp === 'sod' ? 'active' : ''}`}
                  alt="ThirdLine Shield"
                  style={{ maxHeight: '30px' }}
                />
                <div>
                  <span
                    className={`fw-bold ${currentApp === 'sod' ? 'text-primary' : 'text-muted'}`}
                  >
                    Access Management
                  </span>
                  <MutedText as="div">
                    Monitor Users, Roles, and Permissions
                  </MutedText>
                </div>
              </div>
            </NavDropdown.Item>
          )}

          {currentUser.has_analytics_app && (
            <NavDropdown.Item
              onClick={() => switchTo(null, '/dashboards')}
              className={currentApp === 'analytics' ? 'bg-light' : ''}
            >
              <div className="d-flex align-items-center">
                <img
                  src={ThirdLineShieldGold}
                  className={`img-fluid ms-2 me-3 app-switcher-icon ${currentApp === 'analytics' ? 'active' : ''}`}
                  alt="ThirdLine Shield"
                  style={{ maxHeight: '30px' }}
                />
                <div>
                  <span
                    className={`fw-bold ${currentApp === 'analytics' ? 'text-primary' : 'text-muted'}`}
                  >
                    ThirdLine Analytics
                  </span>
                  <MutedText as="div">
                    No code analytics for financial processes
                  </MutedText>
                </div>
              </div>
            </NavDropdown.Item>
          )}

          {currentUser.has_datum_app && (
            <NavDropdown.Item
              onClick={() => switchTo('datum', '/datum')}
              className={currentApp === 'datum' ? 'bg-light' : ''}
            >
              <div className="d-flex align-items-center">
                <img
                  src={DatumLogo}
                  className={`img-fluid ms-2 me-3 app-switcher-icon ${currentApp === 'datum' ? 'active' : ''}`}
                  alt="Datum Insights"
                  style={{ maxHeight: '30px' }}
                />
                <div>
                  <span
                    className={`fw-bold ${currentApp === 'datum' ? 'text-primary' : 'text-muted'}`}
                  >
                    Datum Insights
                  </span>
                  <MutedText as="div">
                    Power BI dashboards and reporting insights
                  </MutedText>
                </div>
              </div>
            </NavDropdown.Item>
          )}
        </div>
      </NavDropdown>
    </ul>
  )
}

export default AppSwitcher
